module.exports = {
  backendUrl:"https://split-check-vhbp.vercel.app",
  // backendUrl: "http://localhost:8000",

  GoogleLoginUrl: "https://split-check-vhbp.vercel.app/auth/google",
  // GoogleLoginUrl: "http://localhost:8000/auth/google",

  // Add more variables as needed
};
